/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_DeletedInputs */

const zh_sidebar_deleted = /** @type {(inputs: Sidebar_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已删除`)
};

const en_sidebar_deleted = /** @type {(inputs: Sidebar_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

const es_sidebar_deleted = /** @type {(inputs: Sidebar_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminado`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Sidebar_DeletedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_deleted = /** @type {((inputs?: Sidebar_DeletedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_DeletedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_deleted(inputs)
	if (locale === "en") return en_sidebar_deleted(inputs)
	return es_sidebar_deleted(inputs)
});